import i18next, { type ParseKeys, type TOptions } from 'i18next';

/**
 * Translate outside React — the lib/ and utils/ helpers that build text for the screens. Same i18next instance
 * the app initialises in ./index.ts. Before that (and in node tests, which never initialise it) it returns the
 * key plus its values — `inbox.webVisitor {"tail":"4e45"}` — so helper tests assert keys and values, not wording.
 */
export function tr(key: ParseKeys, options?: TOptions): string {
  if (i18next.isInitialized) return String(i18next.t(key, options as never));
  return options ? `${key} ${JSON.stringify(options)}` : key;
}

/** The current UI language for Intl date / number formatting (`mn`, `en`, …). */
export function uiLocale(): string | undefined {
  return i18next.resolvedLanguage || undefined;
}
